import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { hotracoApi } from './service';

export const store = configureStore({
  reducer: {
    [hotracoApi.reducerPath]: hotracoApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(hotracoApi.middleware),
});

setupListeners(store.dispatch);
